import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  AreaChart,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteTemporaryFilters,
  getL1SheetProperty,
  getL2SheetProperty,
  getWorkbookProperty,
  removeLevel2Properties,
  setFiltersToOtherSheets,
  setLevel2Properties,
  setWorkbookProperty,
  updateLevel2Properties,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import { lineTransformData } from "../../VizComponents/Utils/lineTransformData";
import { nanoid } from "@reduxjs/toolkit";
import {
  getSheetControls,
  setSheetControls,
} from "../../../features/reduxworkbook/WorkbookControllingSlice";
import { formatNumber } from "../Utils/FormatNumbers";
import { sortData } from "../Utils/SortData";
import { CustomTooltip } from "../Custom/CustomTooltipContent";
import { CustomLegend } from "../Custom/CustomLegendContent";
import { CalculateAction, handleClicked } from "../../actions/Action";
import { handleHeirarchy } from "../Utils/HandleHeirarchy";
import {
  adjustOpacity,
  dispatchSortValues,
  stackedBarChartPosition,
} from "../Utils/ChartsFunctions";
import { useNavigate } from "react-router-dom";

const AreaChartComp = ({
  Data,
  Sheetid,
  rowKeys: rawRowKeys,
  valueKeys,
  groupByKeys = [],
  toolTipKeys,
  hideXAxis,
  hideYAxis,
  hiddenLabels = [],
  sortProperties,
  isAnimataionOff,
  vizType,
  isAreaInBignumberChart,
  dataSourceID,
}) => {
  console.log("area running");

  let timer;
  const reduxActiveIndex = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "activeIndex" })
  );
  const reduxClickedCaption = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "clickedCaption" })
  );
  // console.log(reduxActiveIndex);
  // console.log(reduxClickedCaption);
  const navigate = useNavigate(); // For URL navigation

  const rowKeys = rawRowKeys.map((item) => item.responseKey);
  // console.log(rowKeys);

  const columnResponseKeys = groupByKeys.map((item) => item.responseKey);

  const SufixPrefix = { ...valueKeys.map((item) => item.numberFormat) };
  const [clickedCaption, setClickedCaption] = useState(
    (reduxClickedCaption !== undefined && reduxClickedCaption) || []
  );
  const [activeIndex, setActiveIndex] = useState(reduxActiveIndex || []);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [clickTimeoutState, setClickTimeoutState] = useState(null);
  const [longestLabelWidth, setLongestLabelWidth] = useState(0);
  const leftMargin = Math.ceil(longestLabelWidth) + 10;
  const dispatch = useDispatch();
  const sheetsArray = useSelector((state) =>
    getWorkbookProperty(state, "sheets")
  );

  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const getOnClickProperties = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "onClick");
  });
  const getOnDoubleClickProperties = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "actions", "onDoubleClick")
  );
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || [];
  const workbookId =
    useSelector((state) => getWorkbookProperty(state, "_id")) || [];
  const workbookType =
    useSelector((state) => getWorkbookProperty(state, "type")) || [];
  const filterArray = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "filters")
  );
  // console.log(hoverIndex);

  const {
    isLabelVisible,
    labelPosition,
    labelFontSize,
    labelFontColor,
    labelRotate,
    lineTypes,
    colorSchemeid,
    lineSize,
    isStackbarVisible,
    isLegendVisible,
    legendAlign,
    legendVerticalAlign,
    legendLayout,
    colorMapping,
    isAxeslabelVisible,
    labelAxesFontSize,
    labelAxesFontColor,
    transparentColor,
    isLegendBold,
    legendFontColor,
    isTitleBold,
    Title,
    isTileVisible,
    TitleFontColor,
    TitleSize,
    valueAlign,
  } = customizationObject;
  // console.log(transparentColor);
  // const transparentPoint = transparentColor / 100

  const colorScheme = getColourSchemeByID(colorSchemeid);
  const COLORS = colorScheme?.colors || ["#007a87"];

  const {
    table: transformedData,
    lines: uniqueColumnValues,
    transformedTooltipKeys,
  } = useMemo(() => {
    return lineTransformData(
      Data,
      rawRowKeys,
      groupByKeys,
      valueKeys,
      toolTipKeys
    );
  }, [Data, groupByKeys, rawRowKeys, valueKeys, toolTipKeys]);
  const xa = groupByKeys[0];
  const yb = valueKeys[0];

  const ybiax = valueKeys[1];
  const xAxisResponseKey = xa?.columnName;
  const yAxisCaption = yb?.caption;
  const ybiaXialCaption = ybiax?.caption;
  // console.log(uniqueColumnValues);
  let newArray = null;
  if (!newArray) {
    newArray =
      uniqueColumnValues.length && valueKeys.length
        ? [
            ...uniqueColumnValues,
            ...valueKeys.map((obj) => `Total ${obj.responseKey}`),
          ]
        : [];
  }
  // console.log("newArray", newArray);
  useEffect(() => {
    if (uniqueColumnValues.length) {
      dispatchSortValues({
        newArray,
        dispatch,
        setSheetControls,
        Sheetid,
      });
    }
  }, [uniqueColumnValues]);

  const sorteData =
    sortProperties.length && rawRowKeys.length
      ? sortData({
          transformedData,
          sortProperties,
          requiredArray: groupByKeys,
        })
      : transformedData;
  // console.log(
  //   sortProperties.length && rawRowKeys.length
  //     ? "data is sorted on frontend side"
  //     : "sorted data is coming from backend side"
  // );

  const nanoId = nanoid();

  const handleClickEvent = (data, index, event) => {
    // Check if event is undefined, fallback to window.event if
    const newEvent = event || window.event;
    // console.log(getOnClickProperties?.action);
    if (!getOnClickProperties?.action && !getOnDoubleClickProperties?.action) {
      handleClicked({
        data: uniqueColumnValues,
        index,
        event,
        requiredArray: rawRowKeys,
        hoverIndex,
        dispatch,
        deleteTemporaryFilters,
        setFiltersToOtherSheets,
        Sheetid,
        clickedCaption,
        setClickedCaption,
        activeIndex,
        setActiveIndex,
        vizType,
        dataSourceID,
      });
    } else {
      if (
        getOnClickProperties?.action === "Hierarchy" &&
        rawRowKeys[0] &&
        groupByKeys[0]
      ) {
        const rowCurrentValue = rawRowKeys[0]["rename"];
        const groupCurrentValue = groupByKeys[0]["rename"];
        const partBeforePipeArea = uniqueColumnValues[hoverIndex]
          ? uniqueColumnValues[hoverIndex].split("|")[0]
          : undefined;
        let groupFilterItemIs,
          rowFilterItemIs,
          isGroupHierarchyLastItemExist,
          isRowHierarchyLastItemExist,
          groupIsExpandable,
          rowIsExpandable;
        groupFilterItemIs = {
          columnName: groupByKeys[0].columnName,
          dataType: groupByKeys[0].dataType,
          uuid: groupByKeys[0].uuid,
          rename: groupByKeys[0].rename,
          sourceSheetId: Sheetid,
          nanoId: nanoId,
          selectedFilterValues: [data],
          selectedOperator: "IN",
          filterType: "temporary",
          format: null,
          dataSourceID,
        };
        rowFilterItemIs = {
          columnName: rawRowKeys[0].columnName,
          dataType: rawRowKeys[0].dataType,
          uuid: rawRowKeys[0].uuid,
          rename: rawRowKeys[0].rename,
          sourceSheetId: Sheetid,
          nanoId: nanoId,
          selectedFilterValues: [partBeforePipeArea],
          selectedOperator: "IN",
          filterType: "temporary",
          format: null,
          dataSourceID,
        };
        const rowHierarchy = rowCurrentValue
          ? hierarchy.find((item) =>
              item.hierarchyArray.find((arr) => arr.rename === rowCurrentValue)
            )
          : null;
        const groupHierarchy = groupCurrentValue
          ? hierarchy.find((item) =>
              item.hierarchyArray.find(
                (arr) => arr.rename === groupCurrentValue
              )
            )
          : null;
        rowIsExpandable =
          rowHierarchy !== undefined && rowHierarchy !== null ? true : false;
        groupIsExpandable =
          groupHierarchy !== undefined && groupHierarchy !== null
            ? true
            : false;
        isGroupHierarchyLastItemExist =
          groupHierarchy !== undefined &&
          groupHierarchy.hierarchyArray[
            groupHierarchy.hierarchyArray.length - 1
          ]["rename"] === groupCurrentValue;
        isRowHierarchyLastItemExist =
          rowHierarchy !== undefined &&
          rowHierarchy.hierarchyArray[rowHierarchy.hierarchyArray.length - 1][
            "rename"
          ] === rowCurrentValue;

        if (clickTimeoutState) {
          clearTimeout(clickTimeoutState);
          setClickTimeoutState(null);
          // console.log("double clicked");
          handleHeirarchy({
            headerId: groupCurrentValue,
            foundHierachy: groupHierarchy,
            requiredArray: [],
            dispatch: dispatch,
            functionToAddAndUpdate: updateLevel2Properties,
            functionToRemove: removeLevel2Properties,
            Sheetid: Sheetid,
            vizType: vizType,
            functionWillBe: "replaceItemWithNextItem",
            groupHierarchy,
            rowHierarchy,
            rowCurrentValue,
            groupCurrentValue,
            groupIsExpandable,
            rowIsExpandable,
          });
          if (groupIsExpandable && !isGroupHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: groupFilterItemIs,
                itemInArray: true,
              })
            );
          }
          if (rowIsExpandable && !isRowHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: rowFilterItemIs,
                itemInArray: true,
              })
            );
          }
        } else {
          const timeout = setTimeout(() => {
            setClickTimeoutState(null);
            // console.log("single clicked");

            handleHeirarchy({
              headerId: groupCurrentValue,
              foundHierachy: groupHierarchy,
              requiredArray: [],
              dispatch: dispatch,
              functionToAddAndUpdate: updateLevel2Properties,
              functionToRemove: removeLevel2Properties,
              Sheetid: Sheetid,
              vizType: vizType,
              functionWillBe: "replaceItemWithpreviousItem",
              groupHierarchy,
              rowHierarchy,
              rowCurrentValue,
              groupCurrentValue,
              groupIsExpandable,
              rowIsExpandable,
            });

            const findRemoveAbleItem = (
              hierarchyArray,
              currentIndex,
              filterArray
            ) => {
              // console.log(currentIndex);
              const heirarchyPreivousItemIs =
                hierarchyArray[currentIndex - 1].uuid;
              // console.log(heirarchyPreivousItemIs);
              const filterItemIs = filterArray.find(
                (filterItem) => filterItem.uuid === heirarchyPreivousItemIs
              );
              // console.log(filterItemIs);
              if (filterItemIs) {
                return filterItemIs;
              }
              return undefined;
            };

            const groupCurrentIndex =
              groupHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === groupCurrentValue
              ) ?? -1;

            const rowCurrentIndex =
              rowHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === rowCurrentValue
              ) ?? -1;

            const groupRemoveAbleItemIs =
              groupCurrentIndex > 0
                ? findRemoveAbleItem(
                    groupHierarchy.hierarchyArray,
                    groupCurrentIndex,
                    filterArray
                  )
                : undefined;

            const rowRemoveAbleItemIs =
              rowCurrentIndex > 0
                ? findRemoveAbleItem(
                    rowHierarchy.hierarchyArray,
                    rowCurrentIndex,
                    filterArray
                  )
                : undefined;

            if (groupIsExpandable && groupRemoveAbleItemIs !== undefined) {
              dispatch(
                removeLevel2Properties({
                  reduxKey: "filters",
                  parentKey: "query",
                  value: groupRemoveAbleItemIs,
                  Sheetid,
                  itemInArray: true,
                })
              );
            }
            if (rowIsExpandable && rowRemoveAbleItemIs !== undefined) {
              dispatch(
                removeLevel2Properties({
                  reduxKey: "filters",
                  parentKey: "query",
                  value: rowRemoveAbleItemIs,
                  Sheetid,
                  itemInArray: true,
                })
              );
            }
          }, 250);
          setClickTimeoutState(timeout);
        }
      } else {
        if (rawRowKeys.length && groupByKeys.length) {
          if (timer) {
            //it is a second click
            clearTimeout(timer);
            timer = null;
            // console.log("double");
            CalculateAction({
              data: uniqueColumnValues,
              index,
              event: newEvent,
              requiredArray: rawRowKeys,
              hoverIndex,
              dispatch,
              deleteTemporaryFilters,
              setFiltersToOtherSheets,
              Sheetid,
              clickedCaption,
              setClickedCaption,
              activeIndex,
              setActiveIndex,
              vizType,
              rawRowKeys,
              actionsProperty: getOnDoubleClickProperties,
              setWorkbookProperty,
              workbookId,
              workbookType,
              navigate,
              dataSourceID,
              sheetsArray,
            });
          } else {
            timer = setTimeout(() => {
              // console.log("single");
              CalculateAction({
                data: uniqueColumnValues,
                index,
                event: newEvent,
                requiredArray: rawRowKeys,
                hoverIndex,
                dispatch,
                deleteTemporaryFilters,
                setFiltersToOtherSheets,
                Sheetid,
                clickedCaption,
                setClickedCaption,
                activeIndex,
                setActiveIndex,
                vizType,
                rawRowKeys,
                actionsProperty: getOnClickProperties,
                setWorkbookProperty,
                workbookId,
                workbookType,
                navigate,
                dataSourceID,
                sheetsArray,
              });
              timer = null;
            }, 300);
            // console.log(timer);
          }
        } else {
          console.error(
            `${rawRowKeys.length} should be greater than zero ${groupByKeys.length} should be greater than zero`
          );
        }
      }
    }
  };
  useEffect(() => {
    // console.log(Sheetid);
    dispatch(
      setSheetControls({
        Sheetid: Sheetid,
        controls: {
          activeIndex,
          clickedCaption,
        },
        calledFrom: "dispatch useEffect of Area chart",
      })
    );
  }, [activeIndex, clickedCaption]);

  const tickFormatter = (tick) => {
    // console.log(SufixPrefix.mode === "Manual");

    if (typeof tick === "number") {
      const formattedTick = formatNumber(tick, SufixPrefix);

      // Create a temporary canvas to measure the text width
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = "12px Arial"; // Use the same font as the chart
      const textWidth = context.measureText(formattedTick).width;

      // Update the longest label width if this tick is longer
      if (SufixPrefix.mode === "Manual") {
        setLongestLabelWidth(
          (prevWidth) => Math.max(prevWidth, textWidth) - 20
        );
      } else {
        setLongestLabelWidth(
          (prevWidth) => Math.max(prevWidth, textWidth) - 10
        );
      }

      return formattedTick;
    }
    return tick;
  };

  const handleLineMouseEnter = (lineIndex) => {
    setHoverIndex(lineIndex);
  };

  const handleLineMouseLeave = () => {
    setHoverIndex(null);
  };

  const yAxisFormatter = (value) => {
    return isStackbarVisible
      ? `${value}%` // Show as percentage when `isStackbarVisible` is true
      : formatNumber(value, SufixPrefix); // Otherwise, show formatted number
  };
  //  margin  function
  const { left, top, bottom, right } = stackedBarChartPosition(
    isAxeslabelVisible,
    false,
    SufixPrefix,
    0,
    0,
    false,
    longestLabelWidth,
    {}
  );
  //resize window
  const containerRef = useRef(null);
  const [labelAxesFontSizes, setLabelAxesFontSize] =
    useState(labelAxesFontSize);
  useEffect(() => {
    const updateSizes = () => {
      if (!containerRef.current) return;
      const containerWidth = containerRef.current.offsetWidth;
      const containerHeight = containerRef.current.offsetHeight;
      const maxSize = Math.min(containerWidth, containerHeight) / 2 - 10;
      setLabelAxesFontSize(
        Math.max(10, Math.min(labelAxesFontSize, maxSize * 0.2))
      );
    };

    // Run once on mount
    updateSizes();

    // Attach resize event listener
    window.addEventListener("resize", updateSizes);

    // Use ResizeObserver for better performance
    const resizeObserver = new ResizeObserver(updateSizes);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      window.removeEventListener("resize", updateSizes);
      resizeObserver.disconnect();
    };
  }, [labelAxesFontSize]);
  // find the  hex colors (#RRGGBB)
  function hexToRgba(hex, alpha = 1) {
    // console.log(alpha);

    const parsedHex = hex.replace("#", "");
    const bigint = parseInt(parsedHex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return (
    <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
      <div style={{ width: "100%", height: isTileVisible ? "5%" : "0%" }}>
        {isTileVisible && (
          <div
            className={`w-auto ${isTitleBold ? "font-bold" : ""} ${
              valueAlign === "left"
                ? "text-left"
                : valueAlign === "right"
                ? "text-right"
                : "text-center"
            }`}
            style={{
              fontSize: TitleSize,
              color: TitleFontColor ?? "#bababa",
            }}
          >
            {Title || " Title..."}
          </div>
        )}
      </div>
      <div style={{ width: "100%", height: isTileVisible ? "95%" : "100%" }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            // data={isStackbarVisible ? percentageData : sorteData}
            data={sorteData}
            // margin={
            //   isStackbarVisible
            //     ? { top: 30, left: leftMargin, right: 50 }
            //     : { right: 20, top: 20, left: leftMargin }
            // }
            margin={{
              left: left,
              bottom,
              top,
              right,
            }}
            onClick={(data, event) => {
              if (
                isAreaInBignumberChart === undefined ||
                isAreaInBignumberChart === false
              ) {
                if (hoverIndex !== null) {
                  handleClickEvent(data.activeLabel, hoverIndex, event);
                }
              }
            }}
          >
            <CartesianGrid stroke="url(#gridGradient)" strokeDasharray="3 3" />

            <XAxis
              dataKey={columnResponseKeys[0]}
              tick={{ fill: "#909497" }}
              hide={hideXAxis}
              tickFormatter={isStackbarVisible ? tickFormatter : null}
              label={
                isAxeslabelVisible
                  ? {
                      content: ({ viewBox }) => {
                        const { x, y, width } = viewBox;
                        return (
                          <text
                            x={x + width / 2} // Center horizontally
                            y={y + 50} // Adjust as needed
                            textAnchor="middle" // Center text horizontally
                            fill={labelAxesFontColor}
                            dominantBaseline="middle"
                            style={{
                              fontWeight: "normal",
                              fontSize: labelAxesFontSizes,
                            }} // Center text vertically
                          >
                            {xAxisResponseKey}
                          </text>
                        );
                      },
                    }
                  : null
              }
            />
            <YAxis
              tick={{ fill: "#909497" }}
              // domain={[0, 100]}
              hide={hideYAxis}
              // tickFormatter={tickFormatter}
              tickFormatter={isStackbarVisible ? yAxisFormatter : tickFormatter}
              label={
                isAxeslabelVisible
                  ? {
                      content: ({ viewBox }) => {
                        const { x, y, height } = viewBox;
                        return (
                          <text
                            x={x - 10}
                            y={y + height / 2}
                            textAnchor="middle"
                            fill={labelAxesFontColor}
                            dominantBaseline="middle"
                            transform={`rotate(-90, ${x - 10}, ${
                              y + height / 2
                            })`}
                            style={{
                              fontWeight: "normal",
                              fontSize: labelAxesFontSizes,
                            }}
                          >
                            {yAxisCaption}
                          </text>
                        );
                      },
                    }
                  : null
              }
            />

            <Tooltip
              content={
                <CustomTooltip
                  // toolTipKeys={toolTipKeys}
                  toolTipArray={toolTipKeys}
                  isPercentageTooltip={isStackbarVisible}
                  SufixPrefix={SufixPrefix}
                  // COLORS={COLORS}
                  currentLineIndex={hoverIndex}
                  colorSchemeid={colorSchemeid}
                  rowKeys={rawRowKeys}
                  valueKeys={valueKeys}
                  columnKeys={groupByKeys}
                  // uniqueColumnValues={uniqueColumnValues}
                  headerKeys={uniqueColumnValues}
                  tooltipKeys={transformedTooltipKeys}
                  chartType={"areachart"}
                  colorMapping={colorMapping}
                />
              }
            />

            {isLegendVisible && (
              <Legend
                iconType="rect"
                align={legendAlign.value}
                verticalAlign={legendVerticalAlign.value}
                layout={legendLayout.value}
                fill={legendFontColor}
                legendFontWeight={isLegendBold}
                content={
                  <CustomLegend
                    {...{
                      align: legendAlign.value,
                      verticalAlign: legendVerticalAlign.value,
                      layout: legendLayout.value,
                      valueKeys,
                      legendFontColor,
                      isLegendBold,
                    }}
                  />
                }
              />
            )}

            {uniqueColumnValues.map((item, index) => {
              // console.log(item);
              // console.log(valueKeys);
              const baseColor =
                colorMapping?.[item] || COLORS[index % COLORS.length];

              // console.log(baseColor);

              const isActive = activeIndex.includes(index);

              const strokeColor =
                activeIndex.length === 0
                  ? baseColor
                  : isActive
                  ? adjustOpacity(baseColor, vizType)
                  : baseColor;
              // console.log(vizType);

              // const isActive =
              //   activeIndex.length && !activeIndex.includes(index);
              // const strokeColor =
              //   activeIndex.length === 0
              //     ? COLORS[index % COLORS.length]
              //     : isActive
              //     ? adjustOpacity(COLORS[index % COLORS.length], vizType)
              //     : COLORS[index % COLORS.length];

              const calculateLineID = () => {
                const arrayOfString = item.split("|");
                return arrayOfString[arrayOfString.length - 1];
              };

              const measureValue = calculateLineID();
              // console.log(measureValue);

              const calculatedlineId = calculateLineID ? measureValue : null;
              const { numberFormat } = valueKeys.find(
                (valueObject) => valueObject.responseKey === measureValue
              ) || { mode: "Auto" };
              // console.log(numberFormat);
              //transperant color
              const transparentPoint =
                typeof transparentColor === "number"
                  ? Math.min(transparentColor / 100, 1)
                  : 0.5;

              // console.log(transparentPoint);

              return (
                <Area
                  key={item}
                  type={lineTypes?.value || "monotone"}
                  dataKey={item}
                  stackId={calculatedlineId}
                  stroke={strokeColor}
                  // fill={COLORS[index % COLORS.length]}
                  // fill={strokeColor}
                  // fillOpacity={0.2}
                  fill={hexToRgba(baseColor, transparentPoint)}
                  fillOpacity={transparentPoint}
                  // stackId="1"
                  strokeWidth={lineSize}
                  isAnimationActive={isAnimataionOff}
                  onMouseEnter={() => handleLineMouseEnter(index)}
                  onMouseLeave={handleLineMouseLeave}
                >
                  {isLabelVisible &&
                    Array.isArray(hiddenLabels) &&
                    !hiddenLabels.includes(item) && (
                      <LabelList
                        dataKey={item}
                        position={labelPosition?.value}
                        fontSize={labelFontSize}
                        fill={labelFontColor}
                        fillOpacity={0.2}
                        stroke={labelFontColor}
                        angle={labelRotate}
                        // formatter={isStackbarVisible ? (value) => `${value}%` : null}
                        formatter={
                          isStackbarVisible
                            ? (value) => `${value}%`
                            : (value) => formatNumber(value, numberFormat)
                        }
                      />
                    )}
                </Area>
              );
            })}
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AreaChartComp;
